export default __webpack_public_path__ + "bf1b3a0abd485e2cefb0837d60cc0441.png";